import * as React from 'react';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import { IColumnDef } from '../../../../../../Types/ColumnDefType';
import { IUIUrval } from '../../../../../../Types/UrvalTypes';
import {
  findValue,
  getAttributeFormatter,
} from '../ObjectTable/ObjectTableRow';
import EDGrid from '../../../../../../BaseComponents/GridComponents/EDGrid';
import EDTypography from '../../../../../../BaseComponents/Typography/EDTypography';
import { ModelContext } from '../../../../../../Model/ModelContext/ModelContext';
import { IClientBusinessModel } from '../../../../../../Types/ClientModelTypes';
import EDExpansionPanel from '../../../../../../BaseComponents/Accordion/EDExpansionPanel';
import { TSelectedDetail } from '../../../../../../Types/MasterDetailTypes';

interface IProps {
  columns: readonly IColumnDef[];
  item: { id: string; _version: number };
  urval: IUIUrval | null;
  selectedId: TSelectedDetail;
  selectDetail?: (id: string, force?: boolean) => void;
  inlineDetail: React.ReactNode;
  collection: IClientBusinessModel;
  classes?: any;
}

const styles = (theme: Theme, _params: any, classes: any) => ({
  subtitle1: {
    marginBottom: -4,
  },
  body2: {
    paddingTop: 4,
  },
  flexContainer: {
    display: 'flex',
  },
  item: {
    '&:hover': {
      background: theme.customProperties.Fade.BlueGray.hover,
    },
  },
  selectedItem: {
    background: theme.customProperties.Fade.BlueGray.selected,
  },
  checkbox: {
    opacity: 0,
    transition: 'opacity 100ms ease',
    [`.${classes.item}:hover &`]: {
      opacity: 1,
    },
  },
  itemContainer: {
    display: 'flex',
    flexDirection: 'row-reverse' as 'row-reverse',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  inactiveColor: {
    color: theme.palette.text.secondary,
  },
  childrenContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
});

/**
 *  Komponent som ritar ut namn för alla kolumner och en expansionsikon för detaljer
 */
const BusinessDataExpandableListItem: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { avenyCollectionMap } = React.useContext(ModelContext);
  const selected = props.selectedId === props.item.id;
  const headerColumns = props.columns.filter(col => col.header);
  const header = (
    <span className={props.classes.flexContainer}>
      <span>
        <EDTypography
          variant="caption"
          classes={{
            subtitle1: props.classes.subtitle1,
          }}
        >
          {headerColumns.map(x => x.caption).join(' - ')}
        </EDTypography>
        <EDTypography bold variant="h6">
          {headerColumns
            .map(col => {
              const { formatter, displayParams } = getAttributeFormatter(
                col.attributeDef,
                props.collection,
                avenyCollectionMap
              );

              return formatter.displayer.display(
                findValue(props.item, col.attributeDef.split('.')) || '',
                true,
                displayParams
              );
              // return findValue(props.item, col.attributeDef.split('.')) || '';
            })
            .join(' - ')}
        </EDTypography>
      </span>
    </span>
  );

  return (
    <EDExpansionPanel
      label={
        <EDGrid container spacing={0}>
          {header}
        </EDGrid>
      }
    >
      <>{selected ? props.inlineDetail : null}</>
    </EDExpansionPanel>
  );
};

export default withStyles(BusinessDataExpandableListItem, styles);
